import { useEffect } from "react"
import styled from "styled-components"
import QuickEntry from "./QuickEntry"

export const QuickEntryModalAtom = styled.div<{$interactive: boolean}>`
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    padding: 62px 19px 0px 19px;
    gap: 22px;

    position: absolute;
    width: 100%;
    height: 100%;
    left: 0px;
    top: 0px;
    z-index: 10;

    pointer-events: ${props => props.$interactive ? 'default' : 'none'};

    box-sizing: border-box;

    background: rgba(0, 0, 0, 0.0);
    background-blend-mode: difference;

    transition: background 300ms;

    &.visible {
        background: rgba(0, 0, 0, 0.5);
    }
`

type QuickEntryModalProps = {
    visible: boolean
    closeHandler: () => void
}

export default function QuickEntryModal(props: QuickEntryModalProps) {
    useEffect(() => {
            setTimeout(() => {
                if(props.visible) {
                    document.getElementById('QuickEntryModal')?.classList.add('visible');
                }else{
                    document.getElementById('QuickEntryModal')?.classList.remove('visible');
                }
            }, 50)
    }, [props.visible]);
    return (<QuickEntryModalAtom id="QuickEntryModal" $interactive={props.visible} onClick={(e: React.MouseEvent) => {if((e.target as HTMLElement).getAttribute('id') === 'QuickEntryModal') props.closeHandler()}}>
        {props.visible ? <QuickEntry modal={true}/> : null}
    </QuickEntryModalAtom>)
}